module.exports = __webpack_public_path__ + "static/recruit-icon-woman02-45e2989ea7c94d2cace8eb70bf7a32d6.png";